import hash from "@emotion/hash"
import styled from "@emotion/styled"

import { useConsole } from "contexts/Console"

import getMediaQuery from "css/breakpoints"
import { Heading as HeadingCN } from "css/classnames"
import { headline50, quote100, headline70, surtitle70, legend110, bold } from "css/text"
import { useLayoutEffect, useRef } from "react"

export const KickerCN = `css-${hash("kicker")}`
export const SubtitleCN = `css-${hash("subtitle")}`

// const PushCenterTextStyle = DiciplineTitle

export const Root = styled.hgroup`
  display: grid;
  grid-template-rows: repeat(2, min-content);
  /* grid-template-columns: max-content; */
  height: fit-content;

  ${({ pushcenter }) =>
    pushcenter &&
    `
      & > h1,
      & > h2,
      & > p {
        background: var(--title-gradient, rgb(var(--green)));
        -webkit-background-clip: text;
        color: transparent;
        background-clip: text;
        display: inline-table; 
        position: relative;
        text-wrap: balance;
        -webkit-text-fill-color: transparent;
        will-change: transform;
      }
      & > p {
        margin-block-start: 0.5rem;
      }

    `}

  & > h2 {
    grid-row-start: 2;
  }

  & > p {
    ${legend110}
    ${bold}
    grid-row-start: 1;
    margin-block-end: 10px;
  }
  & > p:nth-of-type(2) {
    ${({ pushcenter }) => pushcenter && "grid-row-start:3; margin-block-start: 10px;"};
  }
`
export const Title = styled.h2`
  ${({ isPush }) => (isPush ? headline50 : headline70)}

  em {
    color: rgb(var(--green));
    font-style: normal;
  }
`

export const P = styled.span`
  ${surtitle70}
  display: block;
  margin-block-end: 10px;
`

const TitlePushCenter = styled.h2`
  ${headline50}
  pointer-events: none;
  ${getMediaQuery("m", { max: true })} {
    margin-bottom: 14px;
    line-height: 1.2;
  }
  line-height: 1.1;
  text-wrap: pretty;

  em {
    color: rgb(var(--green));
    font-style: normal;
  }

  background: var(--title-gradient, rgb(var(--green)));
  margin-block-end: 1rem;
  -webkit-background-clip: text;
  color: transparent;
  background-clip: text;
  display: inline-table; // Fix text clipping in Firefox 135 ¯\_(ツ)_/¯
  position: relative;
  text-wrap: balance;
  -webkit-text-fill-color: transparent;
  will-change: transform;
  padding-block-end: 7px !important;
`

export default function Heading({ tag = "h2", title, isPush, subtitle, kicker, id, pushCenter }) {
  const console = useConsole()
  const rfmain = useRef(null)
  //*******
  // TO DELETE
  // subtitle = null
  // kicker = null
  //*******

  useLayoutEffect(() => {
    const inside_popin = rfmain.current?.closest(".popin-edito")
    if (!inside_popin) return
    const label = id ?? "modal-heading"
    const labelled = inside_popin.getAttribute("aria-labelledBy")
    if (labelled) return
    rfmain.current?.setAttribute("id", label)
    inside_popin.setAttribute("aria-labelledBy", label)
    inside_popin.removeAttribute("aria-label")
  }, [id])

  return title && (kicker || subtitle) ? (
    <Root className={HeadingCN} pushCenter={pushCenter} ref={rfmain}>
      {kicker && <P className={KickerCN} dangerouslySetInnerHTML={{ __html: kicker }} />}
      {pushCenter ? (
        <TitlePushCenter dangerouslySetInnerHTML={{ __html: title }} id={id} />
      ) : (
        <Title as={tag} isPush={isPush} dangerouslySetInnerHTML={{ __html: title }} id={id} />
      )}
      {subtitle && <p className={KickerCN}>{subtitle}</p>}
    </Root>
  ) : title && pushCenter ? (
    <TitlePushCenter pushcenter={pushCenter} dangerouslySetInnerHTML={{ __html: title }} id={id} ref={rfmain} />
  ) : title ? (
    <Title isPush={isPush} as={tag} className={HeadingCN} dangerouslySetInnerHTML={{ __html: title }} id={id} ref={rfmain} />
  ) : null
}
